import React from 'react';
import { Loader2 } from 'lucide-react';

export const Loader = () => {
    return (
        <div className='flex items-center justify-center gap-2 w-full h-full' data-testid='loader'>
            <Loader2 className='h-6 w-6 animate-spin' style={{ color: '#076769' }} role='progressbar' aria-label='Loading' />
            <div className='text-grey-60'>loading...</div>
        </div>
    );
};
export const LoaderInline = ({ size: _size }: { size?: number }) => {
    return (
        <div className='flex flex-row gap-2 text-gray-500' data-testid='inline-loader'>
            <Loader2 className='h-4 w-4 animate-spin' style={{ color: '#076769' }} />
        </div>
    );
};

export default Loader;
